'use strict';

var _ = require('../mindash');

module.exports = {
  getItem: _.noop,
  setItem: _.noop
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/marty-lib/modules/core/noopStorage.js
// module id = xBBq
// module chunks = 88